export default __webpack_public_path__ + "ec14ca0b40c22e074cd79789aebc4cda.png";